import styled from 'styled-components';
import { getColorWithAlpha } from '@elfsight/lib-utils';
import { ShortenedText, Typography } from '@elfsight/widget-ui';
import { useLingui } from '@lingui/react/macro';
import { useLocationCardProps } from './location-card-settings-context';

export function BusinessAbout() {
  const { textStyle, textColor, businessAbout, businessAboutShortened } =
    useLocationCardProps();
  const { t } = useLingui();
  if (businessAboutShortened) {
    return (
      <StyledShortenedText
        textSize={textStyle?.fontSize}
        textColor={textColor}
        controlCloseText={t`Hide`}
        controlOpenText={t`Read More`}
        controlColor={getColorWithAlpha(textColor, 0.5)}
        text={String(businessAbout)}
      />
    );
  }

  return (
    <StyledTypography
      textStyle={textStyle}
      color={textColor}
      dangerouslySetInnerHTML={{ __html: String(businessAbout) }}
    />
  );
}

const StyledShortenedText = styled(ShortenedText)`
  text-align: inherit !important;
  & {
    a {
      text-decoration: underline;
      color: inherit;
    }
  }
`;

const StyledTypography = styled(Typography)`
  & {
    a {
      text-decoration: underline;
      color: inherit;
    }
  }
`;
